import { defineComponent, ref, shallowRef, watch, onUnmounted, openBlock, createBlock, unref, withCtx, createElementVNode, createElementBlock, Fragment, renderList, normalizeClass, toDisplayString, createVNode, createTextVNode } from 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import '@ssml-editor/core';
import { Button, EditorUtils } from '@ssml-editor/vue';
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
import Popover from '../../../component/popover/popover.js';
import '../../module/phoneme/alphabet.enum.js';
import { SAY_AS_TYPE } from '../../module/say-as/constant.js';
import { SayAsInterpretation } from '../../module/say-as/say-as-interpretation.enum.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import { SayAsInterpretationData } from './constant.js';
import { SayAsMenuService } from './say-as-menu-service.js';
/* empty css                */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "say-as-menu",
  props: {
    cardinal: {},
    digits: {},
    telephone: {},
    name: {},
    address: {},
    id: {},
    characters: {},
    punctuation: {},
    date: {},
    time: {},
    currency: {},
    measure: {},
    editor: {}
  },
  setup(__props) {
    const popoverVisible = ref(false);
    const sayAsInterpretationOptions = ref([]);
    const sayAsMenuService = shallowRef();
    const props = __props;
    function show() {
      popoverVisible.value = true;
    }
    function hide() {
      popoverVisible.value = false;
    }
    function generateSayAsInterpretationOptions(text) {
      const result = [];
      Object.keys(SayAsInterpretationData).forEach((key) => {
        if (props[key]) {
          let disabled = true;
          const validate = props[key]?.validate;
          if (validate && sayAsMenuService.value && validate(text, sayAsMenuService.value.getDefaultValidateMethod(key))) {
            disabled = false;
          }
          result.push({
            label: SayAsInterpretationData[key],
            value: key,
            disabled
          });
        }
      });
      return result;
    }
    function menuClickHandler() {
      const editor = props.editor;
      if (editor) {
        sayAsMenuService.value ??= new SayAsMenuService(editor);
        const node = EditorUtils.findSelectedNodeByType(editor, SAY_AS_TYPE);
        if (node) {
          EditorUtils.selectByNode(editor, node);
        } else {
          EditorUtils.trimSelection(editor);
        }
        if (!sayAsMenuService.value.isDisabled()) {
          if (editor.selection) {
            const text = EditorUtils.getText(editor, editor.selection);
            sayAsInterpretationOptions.value = generateSayAsInterpretationOptions(text);
          }
          show();
        }
      }
    }
    function listItemClickHandler({ label, value, disabled }) {
      if (!disabled) {
        sayAsMenuService.value?.setNode(SayAsInterpretation.fromString(value), label);
        hide();
      }
    }
    function ssmlMarkClickHandler(_eventName, _editor, elem) {
      if (elem.type === SAY_AS_TYPE) {
        sayAsMenuService.value = void 0;
        menuClickHandler();
      }
    }
    watch(() => props.editor, (newValue, oldValue) => {
      oldValue?.off("ssml-mark-click", ssmlMarkClickHandler);
      newValue?.on("ssml-mark-click", ssmlMarkClickHandler);
    }, {
      immediate: true
    });
    onUnmounted(() => {
      props.editor?.off("ssml-mark-click", ssmlMarkClickHandler);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Popover), {
        modelValue: popoverVisible.value,
        "onUpdate:modelValue": ($event) => popoverVisible.value = $event,
        "show-footer": false
      }, {
        reference: withCtx(() => [
          createVNode(unref(Button), {
            "icon-class": "iconfont-ssml-editor icon-ssml-editor-dancidufa",
            onClick: menuClickHandler
          }, {
            default: withCtx(() => [
              createTextVNode("读法")
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createElementVNode("ul", { class: "se-say-as" }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(sayAsInterpretationOptions.value, (item, index) => {
              return openBlock(), createElementBlock("li", {
                key: index,
                class: normalizeClass({ "disabled": item.disabled }),
                onClick: ($event) => listItemClickHandler(item)
              }, toDisplayString(item.label), 11, ["onClick"]);
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=say-as-menu.vue2.js.map
